import { EntityRef } from '@core/services/gbe-error-parser/warning.model';

/** The entities singled out on the current page, named the way a finding's context names them. */
export interface EntitySelection {
  contextEntityType: string;
  uids: ReadonlySet<string>;
}

/** Extra uids of the selection's type a reference stands for (e.g. a stop's route); none by default. */
export type RefResolver = (ref: EntityRef) => readonly string[];

/**
 * An unnamed entity (`uid: null`) never matches: it says a finding is about *some* entity of
 * that type, not about one the user selected.
 */
export function citesSelection(
  refs: readonly EntityRef[],
  selection: EntitySelection,
  resolve?: RefResolver
): boolean {
  return refs.some((ref) => {
    if (ref.uid === null) return false;
    if (ref.entityType === selection.contextEntityType) return selection.uids.has(ref.uid);
    return resolve?.(ref).some((uid) => selection.uids.has(uid)) ?? false;
  });
}

/**
 * GFE page entity type → the context's entity_type. Upper-casing is the whole mapping: a page's
 * type is the dataspace entity's name, and upper-cased that is the spelling DataLayer's context
 * and the legacy reference table both use (`route` → `ROUTE`, `job_waste_container_step` →
 * `JOB_WASTE_CONTAINER_STEP`). A type whose names disagree needs a lookup here.
 */
export function contextEntityTypeOf(pageEntityType: string): string {
  return pageEntityType.toUpperCase();
}
